$(document).ready(function () {
    var offset = $('.blog-filter-main-content').offset().top - 500;

    $('html, body').animate({
        scrollTop: offset
    }, 'slow');
});
$(document).ready(function () {
$(".blog-titletag.blog-active").each(function () {
  var tag = $(this).data("tag-blog");
  $('[data-tag-blog-content="' + tag + '"]').addClass("active").show();
});

$(".blog-titletag").click(function () {
  var tag = $(this).data("tag-blog");
  $(".blog-titletag").removeClass("blog-active");
  $(".blog-content-blogs").removeClass("active").hide();
  $(this).addClass("blog-active");
  $('[data-tag-blog-content="' + tag + '"]').addClass("active").show();
});


  // Load more button click event
$(function () {
		$(".blog-content-blogs.active .blog-content-blogs-main-inner").slice(0, 1).css('display','grid');
		$("body").on('click touchstart', '.blog-content-url', function (e) {
			// e.preventDefault();
			$(".blog-content-blogs.active .blog-content-blogs-main-inner:hidden").slice(0, 1).css('display','grid');
			if ($(".blog-content-blogs.active .blog-content-blogs-main-inner:hidden").length == 0) {
				$(".blog-content-blogs.active .blog-content-url").css('visibility', 'hidden');
			}
		});
	}); 

});


// Function to initialize Slick slider for mobile only
// function initMobileSlickSlider() {
//   if ($(window).width() <= 768) { // Adjust the breakpoint as needed
//     $('.article-section-block-main-flex').not('.slick-initialized').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       autoplay: true,
//       infinite: false,
//       arrows: true,
//       adaptiveHeight: true
//     });
//   }
// }
// // Call the function on page load
// $(document).ready(function () {
//   initMobileSlickSlider();
// });

// // Call the function when the window is resized
// $(window).resize(function () {
//   initMobileSlickSlider();
// });

// $(".prev-btn").click(function () {
//     $(".article-section-block-main-flex").slick("slickPrev");
// });

// $(".next-btn").click(function () {
//     $(".article-section-block-main-flex").slick("slickNext");
// });
// $(".prev-btn").addClass("slick-disabled");
// $(".article-section-block-main-flex").on("afterChange", function () {
//     if ($(".slick-prev").hasClass("slick-disabled")) {
//         $(".prev-btn").addClass("slick-disabled");
//     } else {
//         $(".prev-btn").removeClass("slick-disabled");
//     }
//     if ($(".slick-next").hasClass("slick-disabled")) {
//         $(".next-btn").addClass("slick-disabled");
//     } else {
//         $(".next-btn").removeClass("slick-disabled");
//     }
// });



